import moment from "moment-jalaali";
import { getMoneyText, localizeNumbers ,getRialMoneyText} from "../../functions";
import { Link } from "react-router-dom";

const PredefinedComponents: { [id: string]: React.FunctionComponent<any> } = {};

PredefinedComponents["link"] = ({ value, urlAddress }) => {
  return (
    <Link to={`${urlAddress}/${value}`} className="link">
      {localizeNumbers(value)}
    </Link>
  );
};

PredefinedComponents["farsi"] = ({ value }) => {
  return <>{localizeNumbers(value)}</>;
};

PredefinedComponents["toman"] = ({ value }) => {
  value = getMoneyText(value).amount;
  return <>{value}</>;
};

PredefinedComponents["rial"] = ({ value }) => {
  value = getRialMoneyText(value).amount;
  return <>{value}</>;
};

PredefinedComponents["date"] = ({ value }) => {
  var date = value.toString().substring(0, 8);
  let m = moment(date, "jYYYYjMMjDD");
  return (
    <>{m.isValid() ? localizeNumbers(m.format("jYYYY/jMM/jDD")) : value}</>
  );
};

export default PredefinedComponents;
